export default __webpack_public_path__ + "static/ubuntu-v20-latin-700-fc38f31d636ef7ea94b75741b6d493c8.ttf";